import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import FactoryManagement from './pages/FactoryManagement';
import TenantList from './pages/TenantList';
import Contracts from './pages/Contracts';
import ContractDetail from './pages/ContractDetail';
import Reports from './pages/Reports';
import IndustryList from './pages/IndustryList';
import PrivateRoute from './components/PrivateRoute';
import RentInvoices from './pages/RentInvoices';
import SupportList from './pages/SupportList';
import Notifications from './pages/Notifications';
import AdminList from './pages/AdminList';
import UserActivityLogs from './pages/UserActivityLogs';
import UtilityManagement from './pages/UtilityManagement';
import ServiceManagement from './pages/ServiceManagement';
import SupportCallLogs from './pages/SupportCallLogs';
import BannerAndPopupManagement from './pages/BannerAndPopupManagement';
import { HistoryOutlined } from '@ant-design/icons';

function App() {
  return (
    <Routes>
      {/* Public Route */}
      <Route path="/login" element={<Login />} />

      {/* Protected Routes */}
      <Route path="/" element={
        <PrivateRoute>
          <MainLayout />
        </PrivateRoute>
      }>
        <Route index element={<Dashboard />} />
        <Route path="factories" element={<FactoryManagement />} />
        <Route path="tenants" element={<TenantList />} />
        <Route path="industries" element={<IndustryList />} />
        <Route path="contracts" element={<Contracts />} />
        
        {/* Sử dụng một router duy nhất với dấu * để xử lý tất cả ID hợp đồng */}
        <Route path="contracts/*" element={<ContractDetail />} />
        <Route path="contract/*" element={<ContractDetail />} />
        
        <Route path="reports" element={<Reports />} />
        <Route path="rent-invoices" element={<RentInvoices />} />
        <Route path="supports" element={<SupportList />} />
        <Route path="notifications" element={<Notifications />} />  
        <Route path="banners-and-popups" element={<BannerAndPopupManagement />} />
        <Route path="admins" element={<AdminList />} />
        <Route path="user-activities" element={<UserActivityLogs />} />
        <Route path="utilities" element={<UtilityManagement />} />
        <Route path="services" element={<ServiceManagement />} />
        <Route path="support-call-logs" element={<SupportCallLogs />} />
        {/* <Route path="settings" element={<Settings />} /> */}
      </Route>

      {/* Redirect any unknown routes to home */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
